import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './ResultPage.css';
import ViewAnswers from './ViewAnswers';

function ResultPage() {
    const navigate = useNavigate();
    const location = useLocation();

    const {
        score,
        total_marks,
        totalQuestions,
        attempted,
        unattempted,
        correct,
        wrong,
        questions,
        selectedAnswers,
        examId,
        topicId
    } = location.state || {};

    const [showAnswers, setShowAnswers] = useState(false);

    const examIdFromQuestions = questions?.[0]?.exam_id;
    const finalExamId = examId || examIdFromQuestions;

    return (
        <div className="result-container">
            <h2 className="result-heading">✅ Exam Submitted Successfully!</h2>
            <p className='result-subtext'>Here's a summary of your performance</p>

            <div className='summary-grid'>
                <div className='summary-item'>
                    <div className='summary-title'>Total Questions</div>
                    <div className='summary-value'>{totalQuestions}</div>
                </div>
                <div className='summary-item'>
                    <div className='summary-title'>Attempted</div>
                    <div className='summary-value'>{attempted}</div>
                </div>
                <div className='summary-item'>
                    <div className='summary-title'>Unattempted</div>
                    <div className='summary-value'>{unattempted}</div>
                </div>
                <div className='summary-item'>
                    <div className='summary-title'>Correct Answers</div>
                    <div className='summary-value'>{correct}</div>
                </div>
                <div className='summary-item'>
                    <div className='summary-title'>Incorrect Answers</div>
                    <div className='summary-value'>{wrong}</div>
                </div>
                <div className='summary-item'>
                    <div className='summary-title'>Score</div>
                    <div className='summary-value'>{total_marks || score}</div>
                </div>
            </div>

            {showAnswers && (
                <ViewAnswers
                    questions={questions}
                    selectedAnswers={selectedAnswers}
                />
            )}

            <div className="result-buttons">
                <button
                    className='view-answers-btn'
                    onClick={() => setShowAnswers(prev => !prev)}
                >
                    {showAnswers ? "Hide Answers" : "View Answers"}
                </button>

                <button
                    className='try-again-btn'
                    onClick={() => {
                        if (!finalExamId) {
                            alert("Cannot retry: Exam ID missing");
                            return;
                        }
                        navigate('/practice', {
                            state: {
                                examId: finalExamId,
                                topicId,
                                subjectId: location.state?.subjectId,
                                questions
                            }
                        });
                    }}
                >
                    Try Again
                </button>

                <button
                    className='dashboard-btn'
                    onClick={() => navigate('/dashboard')}
                >
                    Go to Dashboard
                </button>
            </div>
        </div>
    );
}

export default ResultPage;
